import {reactive} from "vue";

export const sharedState = reactive({
    user_id: null,
    user_label: null,
    user_firstname: null,
    user_profile_image: null,
    user_isAdmin: false,
    session_id: null
});
